import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/'

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'

import * as VueGoogleMaps from 'vue2-google-maps'

import './registerServiceWorker'

const ignoredMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.'

Vue.config.warnHandler = (message, vm, componentTrace) => {
  if (message !== ignoredMessage) {
    console.error(message + componentTrace)
  }
}

Vue.use(VuejsDialog)
// Vue.use(Viewer)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.NODE_ENV === 'production' ? 'AIzaSyBXHTApQxC7eBOhAUSi5kiniwnOdztCyKY' : 'AIzaSyBjMBDEKPU-DE7ZGQA8sYcD10Trmbh6zEI',
    region: 'RO',
    language: 'ro'
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
